import { IController, IScope } from 'angular';

import { IMultiManifestSelector } from '../../../manifest/selector/IManifestSelector';
import { IDeleteOptions } from '../../../manifest/delete/delete.controller';

export class KubernetesV2DeleteManifestConfigCtrl implements IController {
  constructor(private $scope: IScope) {
    'ngInject';
    if (this.$scope.stage.isNew) {
      const defaultSelection: IMultiManifestSelector = {
        location: '',
        account: '',
        kinds: [],
        labelSelectors: {
          selectors: []
        }
      };
      Object.assign(this.$scope.stage, defaultSelection);
      const defaultOptions: IDeleteOptions = {
        gracePeriodSeconds: null,
        cascading: true,
      }
      this.$scope.stage.options = defaultOptions;
      this.$scope.stage.cloudProvider = 'kubernetes';
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/kubernetes/src/v2/pipelines/stages/deleteManifest/deleteManifestConfig.controller.ts